import {
  API_ENDPOINT,
  useClientApiV1AuthChangePasswordUpdateMutation,
} from '../../resources/@types/accountSchema';

function useClientAuthChangePasswordUpdateMutation(
  options?: Parameters<typeof useClientApiV1AuthChangePasswordUpdateMutation>[0]['options'],
) {
  return useClientApiV1AuthChangePasswordUpdateMutation({
    url: API_ENDPOINT.CLIENT_V1_AUTH_CHANGE_PASSWORD,
    options,
  });
}

export default useClientAuthChangePasswordUpdateMutation;
